import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './componentfaq.css'

const Componentfaq = (props) => {
  return (
    <div className={`componentfaq-container1 ${props.rootClassName} `}>
      {props.showDiv === false && (
        <div data-thq="accordion" className="componentfaq-accordion1">
          <details
            data-thq="accordion-trigger"
            className="componentfaq-thq-trigger-elm1"
          >
            <summary
              data-thq="accordion-summary"
              className="componentfaq-thq-summary-elm1"
            >
              <span className="componentfaq-text10 H1_extrasmall">
                {props.question1}
              </span>
              <div
                data-thq="accordion-icon"
                className="componentfaq-thq-icon-container-elm1"
              >
                <svg width="32" height="32" viewBox="0 0 24 24">
                  <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                </svg>
              </div>
            </summary>
          </details>
          <div data-thq="accordion-content">
            <div className="componentfaq-container2">
              <p className="text_medium">
                {props.answer1 ?? (
                  <Fragment>
                    <span className="componentfaq-text29">answer</span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
      {props.showDiv1 === false && (
        <div data-thq="accordion" className="componentfaq-accordion2">
          <details
            data-thq="accordion-trigger"
            className="componentfaq-thq-trigger-elm2"
          >
            <summary
              data-thq="accordion-summary"
              className="componentfaq-thq-summary-elm2"
            >
              <span className="H1_extrasmall">{props.question2}</span>
              <div
                data-thq="accordion-icon"
                className="componentfaq-thq-icon-container-elm2"
              >
                <svg width="32" height="32" viewBox="0 0 24 24">
                  <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                </svg>
              </div>
            </summary>
          </details>
          <div data-thq="accordion-content">
            <div className="componentfaq-container3">
              <p className="text_medium">
                {props.answer2 ?? (
                  <Fragment>
                    <span className="componentfaq-text33">answer</span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
      {props.showDiv2 === false && (
        <div data-thq="accordion" className="componentfaq-accordion3">
          <details
            data-thq="accordion-trigger"
            className="componentfaq-thq-trigger-elm3"
          >
            <summary
              data-thq="accordion-summary"
              className="componentfaq-thq-summary-elm3"
            >
              <span className="componentfaq-text14 H1_extrasmall">
                {props.question3}
              </span>
              <div
                data-thq="accordion-icon"
                className="componentfaq-thq-icon-container-elm3"
              >
                <svg width="32" height="32" viewBox="0 0 24 24">
                  <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                </svg>
              </div>
            </summary>
          </details>
          <div data-thq="accordion-content">
            <div className="componentfaq-container4">
              <p className="text_medium">
                {props.answer3 ?? (
                  <Fragment>
                    <span className="componentfaq-text27">answer</span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
      {props.showDiv3 === false && (
        <div data-thq="accordion" className="componentfaq-accordion4">
          <details
            data-thq="accordion-trigger"
            className="componentfaq-thq-trigger-elm4"
          >
            <summary
              data-thq="accordion-summary"
              className="componentfaq-thq-summary-elm4"
            >
              <span className="componentfaq-text16 H1_extrasmall">
                {props.question4}
              </span>
              <div
                data-thq="accordion-icon"
                className="componentfaq-thq-icon-container-elm4"
              >
                <svg width="32" height="32" viewBox="0 0 24 24">
                  <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                </svg>
              </div>
            </summary>
          </details>
          <div data-thq="accordion-content">
            <div className="componentfaq-container5">
              <p className="text_medium">
                {props.answer4 ?? (
                  <Fragment>
                    <span className="componentfaq-text31">answer</span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
      {props.showDiv4 === false && (
        <div data-thq="accordion" className="componentfaq-accordion5">
          <details
            data-thq="accordion-trigger"
            className="componentfaq-thq-trigger-elm5"
          >
            <summary
              data-thq="accordion-summary"
              className="componentfaq-thq-summary-elm5"
            >
              <span className="componentfaq-text18 H1_extrasmall">
                {props.question5}
              </span>
              <div
                data-thq="accordion-icon"
                className="componentfaq-thq-icon-container-elm5"
              >
                <svg width="32" height="32" viewBox="0 0 24 24">
                  <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                </svg>
              </div>
            </summary>
          </details>
          <div data-thq="accordion-content">
            <div className="componentfaq-container6">
              <p className="text_medium">
                {props.answer5 ?? (
                  <Fragment>
                    <span className="componentfaq-text30">answer</span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
      {props.showDiv5 === false && (
        <div data-thq="accordion" className="componentfaq-accordion6">
          <details
            data-thq="accordion-trigger"
            className="componentfaq-thq-trigger-elm6"
          >
            <summary
              data-thq="accordion-summary"
              className="componentfaq-thq-summary-elm6"
            >
              <span className="componentfaq-text20 H1_extrasmall">
                {props.question6}
              </span>
              <div
                data-thq="accordion-icon"
                className="componentfaq-thq-icon-container-elm6"
              >
                <svg width="32" height="32" viewBox="0 0 24 24">
                  <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                </svg>
              </div>
            </summary>
          </details>
          <div data-thq="accordion-content">
            <div className="componentfaq-container7">
              <p className="text_medium">
                {props.answer6 ?? (
                  <Fragment>
                    <span className="componentfaq-text28">answer</span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
      {props.showDiv6 === false && (
        <div data-thq="accordion" className="componentfaq-accordion7">
          <details
            data-thq="accordion-trigger"
            className="componentfaq-thq-trigger-elm7"
          >
            <summary
              data-thq="accordion-summary"
              className="componentfaq-thq-summary-elm7"
            >
              <span className="componentfaq-text22 H1_extrasmall">
                {props.question7}
              </span>
              <div
                data-thq="accordion-icon"
                className="componentfaq-thq-icon-container-elm7"
              >
                <svg width="32" height="32" viewBox="0 0 24 24">
                  <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                </svg>
              </div>
            </summary>
          </details>
          <div data-thq="accordion-content">
            <div className="componentfaq-container8">
              <p className="text_medium">
                {props.answer7 ?? (
                  <Fragment>
                    <span className="componentfaq-text26">answer</span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
      {props.showDiv7 === false && (
        <div data-thq="accordion" className="componentfaq-accordion8">
          <details
            data-thq="accordion-trigger"
            className="componentfaq-thq-trigger-elm8"
          >
            <summary
              data-thq="accordion-summary"
              className="componentfaq-thq-summary-elm8"
            >
              <span className="componentfaq-text24 H1_extrasmall">
                {props.question8}
              </span>
              <div
                data-thq="accordion-icon"
                className="componentfaq-thq-icon-container-elm8"
              >
                <svg width="32" height="32" viewBox="0 0 24 24">
                  <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                </svg>
              </div>
            </summary>
          </details>
          <div data-thq="accordion-content">
            <div className="componentfaq-container9">
              <p className="text_medium">
                {props.answer8 ?? (
                  <Fragment>
                    <span className="componentfaq-text32">answer</span>
                  </Fragment>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

Componentfaq.defaultProps = {
  showDiv3: false,
  answer7: undefined,
  question5: 'question',
  question6: 'question',
  answer3: undefined,
  answer6: undefined,
  showDiv2: false,
  showDiv7: false,
  question1: 'question',
  question2: 'question',
  question3: 'question',
  showDiv4: false,
  answer1: undefined,
  question8: 'question',
  question7: 'question',
  answer5: undefined,
  showDiv: false,
  answer4: undefined,
  rootClassName: '',
  showDiv5: false,
  showDiv1: false,
  question4: 'question',
  answer8: undefined,
  answer2: undefined,
  showDiv6: false,
}

Componentfaq.propTypes = {
  showDiv3: PropTypes.bool,
  answer7: PropTypes.element,
  question5: PropTypes.string,
  question6: PropTypes.string,
  answer3: PropTypes.element,
  answer6: PropTypes.element,
  showDiv2: PropTypes.bool,
  showDiv7: PropTypes.bool,
  question1: PropTypes.string,
  question2: PropTypes.string,
  question3: PropTypes.string,
  showDiv4: PropTypes.bool,
  answer1: PropTypes.element,
  question8: PropTypes.string,
  question7: PropTypes.string,
  answer5: PropTypes.element,
  showDiv: PropTypes.bool,
  answer4: PropTypes.element,
  rootClassName: PropTypes.string,
  showDiv5: PropTypes.bool,
  showDiv1: PropTypes.bool,
  question4: PropTypes.string,
  answer8: PropTypes.element,
  answer2: PropTypes.element,
  showDiv6: PropTypes.bool,
}

export default Componentfaq
